export const creditCards = {
    layout: {
        listTitle: 'Cartoes de Credito',
        archivedTitle: 'Cartões arquivados',
        newCardTitle: 'Novo Cartao',
        editCardTitle: 'Editar Cartao',
        invoiceTitle: 'Fatura',
        reconcileTitle: 'Conferir com a fatura',
        invoiceReportTitle: 'Relatório da fatura',
    },
    list: {
        screenTitle: 'Meus Cartões',
        archivedButton: 'Cartões arquivados',
        summary: {
            totalLabel: 'Total em faturas',
            noCurrentInvoice: 'Sem fatura atual',
            trendNoCurrentInvoice: 'Sem fatura atual para destacar',
            trendNoBaseline: 'Sem base para comparar com o mês passado',
            trendSameLevel: 'Mesmo nível do mês passado',
            trendLower: '{{percent}} menor que o mês passado',
            trendHigher: '{{percent}} maior que o mês passado',
        },
        activeSection: 'Cartões ativos',
        emptyTitle: 'Nenhum cartão',
        emptySubtitleWithArchived: 'Toque no ícone de arquivados, no topo, para reativar um cartão.',
        emptySubtitle: 'Adicione seu primeiro cartão de crédito',
        emptyAction: 'Adicionar cartão',
        item: {
            subtitleFallback: 'Cartão',
            // Estado da fatura em foco (ADR 0128), dito com todas as letras — "fatura atual"
            // era ambíguo entre a aberta e a que vence agora (CONTEXT.md).
            invoiceLabelOverdue: 'FATURA VENCIDA',
            invoiceLabelClosed: 'FATURA FECHADA',
            invoiceLabelOpen: 'FATURA ABERTA',
            invoiceLabelEmpty: 'SEM FATURA',
            // Fatura seguinte à manchete: a aberta (quando a manchete é fechada/vencida) ou a
            // próxima — "Próxima" só nomeia fatura DEPOIS da aberta.
            openInvoice: 'Aberta: {{amount}}',
            closedInvoice: 'A vencer: {{amount}}',
            nextInvoice: 'Próxima: {{amount}}',
            dueOnDate: 'Vence {{date}}',
            dueOnDay: 'Vence dia {{day}}',
            noDueDate: 'Sem vencimento',
            freeLimit: 'Limite livre: {{amount}}',
            dragHandle: 'Segure para reordenar o cartão',
        },
    },
    home: {
        // helperText/upcomingHelperText do resumo de cartão na Home (gerados hoje
        // em lib/homeSummary.ts → presentHomeCardSummaries, exibidos via CreditCardListItem).
        // 'Vence {{date}}' reutiliza list.item.dueOnDate; 'Próxima fatura' reutiliza timeline.status.projected.
        helperNoOpenInvoice: 'Sem fatura aberta',
        helperCurrentOverdue: 'Atual venceu {{date}}',
        helperClosing: 'Fecha {{date}}',
        helperOverdue: 'Venceu {{date}}',
    },
    archived: {
        fallbackSubtitle: 'Arquivado',
        reactivateButton: 'Reativar',
        emptyTitle: 'Nenhum cartão arquivado',
        emptySubtitle: 'Cartões arquivados aparecem aqui para você reativar quando quiser.',
    },
    form: {
        nameLabel: 'Nome do cartão',
        namePlaceholder: 'Ex: Nubank, Inter',
        brandOrInstitutionLabel: 'Bandeira ou banco',
        brandOrInstitutionPlaceholder: 'Escolher bandeira ou banco',
        lastFourDigitsLabel: 'Últimos 4 dígitos',
        lastFourDigitsPlaceholder: '1234',
        closingDayLabel: 'Fechamento',
        closingDayHint: 'Dia em que a fatura fecha e as compras passam pra próxima.',
        dueDayLabel: 'Vencimento',
        dueDayHint: 'Dia de pagar a fatura.',
        dayValue: 'Dia {{day}}',
        dueOnBusinessDayLabel: 'Vencimento em dias úteis',
        dueOnBusinessDayHint: 'Se o vencimento cair em fim de semana ou feriado nacional, o app mostra e lembra no próximo dia útil, como o banco faz.',
        closingDayToNextInvoiceLabel: 'Compra no dia do fechamento vai para a próxima fatura',
        closingDayToNextInvoiceHint: 'Alguns bancos fazem assim. Ligado, a fatura passa a fechar na véspera e o que você lançar no dia do fechamento já entra na seguinte. Não mexe no que já foi lançado.',
        paymentAccountLabel: 'Conta para pagamento',
        paymentAccountPlaceholder: 'Selecionar conta',
        colorLabel: 'Cor',
        creditLimitLabel: 'Limite de crédito',
        creditLimitOptional: 'Opcional',
        details: {
            show: 'Mais opções',
            hide: 'Ocultar opções',
        },
        unarchiveAction: 'Desarquivar cartão',
        archiveAction: 'Arquivar cartão',
        deleteAction: 'Excluir cartão',
        createAccessibility: 'Criar cartão',
        saveAccessibility: 'Salvar',
        colorSheetTitle: 'Escolha uma cor',
        archiveDialog: {
            unarchiveMessage: 'O cartão voltará a aparecer nas listagens e na visão geral.',
            archiveMessage: 'O cartão será ocultado, mas as faturas e transações já registradas serão mantidas.',
            unarchiveConfirm: 'Desarquivar',
            archiveConfirm: 'Arquivar',
        },
        deleteDialog: {
            message: 'Excluir remove o cartão do app inteiro: faturas, compras e recorrências dele somem das telas e das análises. Só o que já debitou suas contas permanece no extrato. Para manter o histórico, use Arquivar.',
            confirm: 'Excluir tudo',
        },
    },
    healthBadge: {
        reconciledOn: 'Conferida com o banco em {{date}}',
        reconciledItems_one: '{{count}} item conferido',
        reconciledItems_other: '{{count}} itens conferidos',
        uncategorizedA11y_one: '{{count}} item sem categoria, toque para resolver',
        uncategorizedA11y_other: '{{count}} itens sem categoria, toque para resolver',
        showingUncategorized: 'Mostrando sem categoria · ver todos',
        chipUncategorized_one: '{{count}} sem categoria',
        chipUncategorized_other: '{{count}} sem categoria',
    },
    timeline: {
        status: {
            paid: 'Fatura paga',
            projected: 'Próxima fatura',
            closed: 'Fatura fechada',
            partial: 'Fatura parcial',
            overdue: 'Fatura vencida',
            open: 'Fatura aberta',
            empty: 'Sem lançamentos',
        },
        dueDate: 'Vencimento {{date}}',
        dueDateEmpty: 'Vencimento -',
        purchasesRange: 'Compras de {{from}} a {{to}}',
        purchasesUntil: 'Compras até {{date}}',
        purchasesUntilEmpty: 'Compras até -',
        // Balão do ícone de info do rodapé, em tópicos. A janela termina NO fechamento,
        // por isso a primeira linha diz só de quando começa.
        periodTooltip: {
            purchasesFrom: 'Compras a partir de',
            closesOn: 'Fecha em',
        },
    },
    payInvoice: {
        dateFallback: 'Data',
        payButton: 'Pagar {{amount}}',
        back: 'Voltar',
        amountLabel: 'Valor do pagamento',
        remainingHint: 'Fatura · Restante {{amount}}',
        totalLabel: 'Total da fatura',
        paidLabel: 'Já pago',
        minimumLabel: 'Pagamento mínimo',
        belowMinimumWarning: 'Valor abaixo do mínimo — sujeito a juros do rotativo',
        debitAccountLabel: 'Conta para débito',
        selectAccountPlaceholder: 'Selecionar conta...',
        remainder: {
            title: 'Saldo restante',
            summary: 'Faltam {{amount}} para zerar a fatura.',
            rollToNextLabel: 'Levar para a próxima',
            rollToNextHint: 'Soma à fatura seguinte como saldo anterior.',
            adjustLabel: 'Lançar estorno',
            adjustHint: 'Reduz a fatura atual nesse valor e quita.',
            keepOpenLabel: 'Manter em aberto',
            keepOpenHint: 'Deixa o saldo pendente nesta fatura.',
        },
        overpayment: {
            title: 'Pagamento a mais',
            summary: 'Você está pagando {{amount}} além do total da fatura.',
            creditToNextLabel: 'Creditar na próxima fatura',
            creditToNextHint: 'A fatura seguinte já nasce abatida nesse valor.',
            creditLabel: 'Lançar crédito na conta',
            creditHint: 'Devolve o excedente para a conta.',
            extraEntryLabel: 'Lançar ajuste na fatura',
            extraEntryHint: 'Cria um item extra para refletir o valor.',
            lateFeeLabel: 'Lançar como juros/multa',
            lateFeeHint: 'Registra o excedente como juros e multa na fatura.',
            ignoreLabel: 'Ignorar',
            ignoreHint: 'Confirma o pagamento sem ajuste.',
        },
    },
    reconcile: {
        chooseCategory: 'Escolher categoria',
        aiFill: 'Preencher com IA · {{n}}',
        aiFillLoading: 'Preenchendo…',
        aiFillA11y: 'Preencher com IA as {{n}} linhas sem categoria',
        aiFillDone_one: 'A IA preencheu a linha que faltava. Confira antes de lançar.',
        aiFillDone_other: 'A IA preencheu {{n}} de {{count}} linhas. Confira antes de lançar.',
        aiFillNone: 'A IA não conseguiu identificar nenhuma dessas linhas pela descrição.',
        aiFillFailed: 'Não foi possível falar com a IA agora. Tente de novo.',
        aiConsentTitle: 'Preencher com IA',
        aiConsentMessage: 'O Kontto vai enviar à {{provider}} a descrição das linhas sem categoria e os nomes das suas categorias, usando a sua chave. Valor, data, conta e cartão não saem do aparelho. Vale para as próximas faturas; você revoga em Configurações › Assistente IA.',
        aiConsentConfirm: 'Enviar e preencher',
        aiNoKeyTitle: 'Configure a IA primeiro',
        aiNoKeyMessage: 'Para a IA preencher as categorias, cadastre a sua chave em Configurações › Assistente IA. O que o Kontto já preencheu continua valendo.',
        aiNoKeyConfirm: 'Abrir configurações',
        installment: 'Parcela {{number}} · {{date}}',
        installmentWithTotal: 'Parcela {{number}}/{{total}} · {{date}}',
        valueDiffTitle: 'Valor diferente ({{n}})',
        valueDiffHint: 'Mesma compra, valor diverge — marque para corrigir no Kontto',
        valueDiffKontto: 'Kontto: {{amount}}',
        importTitle: 'Lançamentos da fatura ({{n}})',
        importHint: 'Revise a categoria e confirme para lançar tudo',
        missingTitle: 'Faltando no Kontto ({{n}})',
        missingHint: 'Cobranças da fatura sem lançamento — marque para lançar',
        refundsTitle: 'Créditos a lançar ({{n}})',
        refundsHint: 'Créditos da fatura sem lançamento. Estorno abate a categoria da compra; cashback entra como receita e abate a fatura.',
        refundSubtitle: 'Estorno · {{date}}',
        cashbackSubtitle: 'Cashback · {{date}}',
        creditModeRefund: 'Estorno',
        creditModeCashback: 'Cashback',
        cashbackAccount: 'Entra em {{account}}',
        chooseAccount: 'Escolher conta',
        cashbackAccountSheetTitle: 'Conta que recebe o cashback',
        cashbackAccountMissingTitle: 'Escolha a conta do cashback',
        cashbackAccountMissingBody: 'O cashback entra como receita numa conta. Toque em "Escolher conta" na linha dele.',
        extraTitle: 'Só no Kontto ({{n}})',
        extraHint: 'Lançado no app, não veio nesta fatura — confira ou exclua',
        extraSeriesSubtitle: '{{date}} · parcelado/recorrente',
        adjacentTitle: 'Na fatura ao lado ({{n}})',
        adjacentHint: 'Já lançado no Kontto, mas noutra fatura — marque para trazer para esta',
        adjacentSubtitle: 'Fatura de {{month}} · {{date}}',
        adjacentSubtitleKontto: 'Fatura de {{month}} · Kontto: {{amount}}',
        adjacentPaidSubtitle: 'Na fatura de {{month}}, já paga — fica lá',
        matchedItems_one: '{{count}} item conferido',
        matchedItems_other: '{{count}} itens conferidos',
        allReconciled: 'Tudo conferido! A fatura do banco bate com o que você lançou no Kontto.',
        passwordIncorrect: 'Senha incorreta',
        readFailed: 'Falha ao ler a fatura',
        readUnsupportedPdf: 'Este PDF usa uma proteção que o Kontto ainda não lê. Tente exportar o OFX no internet banking.',
        readNoTextPdf: 'Este PDF não tem texto — parece escaneado ou foto. Tente importar por prints.',
        readNoLinesPdf: 'Lemos o PDF, mas não achamos os lançamentos. Tente o OFX do internet banking ou prints da fatura.',
        readNoLinesImages: 'Não achamos lançamentos nesses prints. Confira se cada compra aparece com a data e o valor e tente de novo.',
        readEmptyFile: 'O arquivo chegou vazio. Abra o PDF uma vez no app do banco ou baixe do Drive para o aparelho e tente de novo.',
        readEmptyOfxTitle: 'Esse OFX não tem nenhum lançamento',
        readEmptyOfx: 'Confira no internet banking se exportou a fatura deste cartão e o mês certo.',
        readOfxCsv: 'Não reconhecemos as colunas desse CSV — a conferência precisa de data, descrição e valor. Exporte a fatura em OFX ou PDF e tente de novo.',
        readOfxSpreadsheet: 'Esse arquivo parece uma planilha do Excel — a conferência lê OFX, CSV ou PDF. Exporte a fatura em OFX no internet banking.',
        readOfxImage: 'Esse arquivo é uma imagem — use a opção "Prints da fatura".',
        readOfxPdf: 'Esse arquivo é um PDF — volte e use a opção "PDF da fatura".',
        readOfxHtml: 'Esse arquivo é uma página salva do navegador — a conferência lê OFX, CSV ou PDF. Exporte a fatura em OFX no internet banking.',
        readOfxBinary: 'O Kontto não reconheceu esse arquivo — a conferência lê OFX, CSV ou PDF. Exporte a fatura em OFX no internet banking.',
        readOfxNotOfx: 'Esse arquivo é texto, mas não tem o conteúdo de um OFX. No internet banking, procure a exportação em OFX (às vezes aparece como "Money" ou "Quicken").',
        appliedTitle: 'Fatura conciliada',
        appliedMessage: '{{created}} lançada(s), {{corrected}} corrigida(s).',
        appliedSeries_one: '{{count}} parcelamento projetado nas próximas faturas.',
        appliedSeries_other: '{{count}} parcelamentos projetados nas próximas faturas.',
        appliedMoved_one: '{{count}} trazido da fatura ao lado.',
        appliedMoved_other: '{{count}} trazidos da fatura ao lado.',
        appliedMoveSkipped_one: '{{count}} não pôde ser movido.',
        appliedMoveSkipped_other: '{{count}} não puderam ser movidos.',
        projectSeriesTitle: 'Projetar parcelas futuras',
        projectSeriesSubtitle: 'Compras parceladas viram série: as parcelas restantes entram nas próximas faturas.',
        applyFailed: 'Não foi possível aplicar',
        deleteFailed: 'Não foi possível excluir',
        pickHelp: 'Importe a fatura do banco e o Kontto compara com o que você já lançou — tudo no aparelho, nada sai dele.',
        freeUseBanner_one: 'Você tem <0>{{count}} conferência grátis</0>. Depois, é recurso do Kontto Pro.',
        freeUseBanner_other: 'Você tem <0>{{count}} conferências grátis</0>. Depois, é recurso do Kontto Pro.',
        recommendedLabel: 'Recomendados',
        pdfSourceTitle: 'PDF da fatura',
        pdfSourceSubtitle: 'O arquivo do banco, com ou sem senha.',
        pdfSourceBadge: 'Mais usado',
        ofxSourceTitle: 'Arquivo OFX ou CSV',
        ofxSourceSubtitle: 'Exportado pelo app ou internet banking, sem OCR.',
        ofxSourceBadge: 'Leitura exata',
        imagesSourceTitle: 'Prints da fatura',
        imagesSourceSubtitle: 'Se não tiver PDF, OFX nem CSV — o OCR pode errar valores.',
        optimizedForCount_one: 'Otimizado para {{count}} banco',
        optimizedForCount_other: 'Otimizado para {{count}} bancos',
        banksPreview: 'Nubank, Itaú, Bradesco, Inter e mais.',
        otherBanksNote: 'Outros bancos também funcionam — confira os itens antes de aplicar.',
        pdfProtectedTitle: 'Este PDF está protegido',
        pdfProtectedSubtitle: 'Digite a senha da fatura (geralmente os primeiros dígitos do seu CPF).',
        passwordLabel: 'Senha do PDF',
        openInvoiceButton: 'Abrir fatura',
        processing: 'Lendo a fatura e comparando…',
        importIntro_one: 'Encontramos {{count}} lançamento nesta fatura. Revise a categoria de cada um e confirme para começar com tudo lançado.',
        importIntro_other: 'Encontramos {{count}} lançamentos nesta fatura. Revise a categoria de cada um e confirme para começar com tudo lançado.',
        summaryPurchases: 'Compras na fatura',
        summaryRefunds: 'Créditos',
        negativeAmount: '− {{amount}}',
        inKonttoToday: 'No Kontto hoje',
        checksumWarning: 'Atenção: pode não ter lido todos os itens da fatura. Confira antes de aplicar.',
        nothingToApply: 'Nada a aplicar',
        applyCount_one: 'Aplicar {{count}} item',
        applyCount_other: 'Aplicar {{count}} itens',
        deleteEntryTitle: 'Excluir lançamento',
        deleteSeriesMessage: '"{{description}}" é parcelado/recorrente. O que você deseja excluir?',
        deleteSingleLabel: 'Apenas este',
        deleteSingleDescription: 'Remove só este lançamento.',
        deleteFutureLabel: 'Este e os próximos',
        deleteFutureDescription: 'Apaga este e as próximas ocorrências.',
        deleteAllLabel: 'Todos',
        deleteAllDescription: 'Exclui toda a série.',
        paidWarningTitle: 'Fatura já paga',
        paidWarningMessage: 'A fatura de {{month}} já está paga. Importar mesmo assim?',
        paidWarningContinue: 'Continuar',
        paidWarningBack: 'Voltar',
        extrasPromptTitle: 'Deixar igual à fatura?',
        extrasPromptMessage_one:
            '{{count}} lançamento desta fatura no Kontto não aparece no arquivo importado.',
        extrasPromptMessage_other:
            '{{count}} lançamentos desta fatura no Kontto não aparecem no arquivo importado.',
        extrasPromptDelete_one: 'Excluir e aplicar',
        extrasPromptDelete_other: 'Excluir os {{count}} e aplicar',
        extrasPromptDeleteDescription:
            'A fatura fica igual à do banco. Parcelado/recorrente: sai só o lançamento desta fatura.',
        extrasPromptKeep: 'Manter e aplicar',
        extrasPromptKeepDescription: 'Aplica o restante e mantém esses lançamentos.',
        extrasPromptDeleteOnly_one: 'Excluir e concluir',
        extrasPromptDeleteOnly_other: 'Excluir os {{count}} e concluir',
        deleteOnlyCount_one: 'Excluir {{count}} item da fatura',
        deleteOnlyCount_other: 'Excluir {{count}} itens da fatura',
        extrasDeletedMessage_one: '{{count}} lançamento excluído — fatura igual à do banco.',
        extrasDeletedMessage_other: '{{count}} lançamentos excluídos — fatura igual à do banco.',
    },
    invoice: {
        newEntryAccessibility: 'Lançar no cartão',
        manualAdjustments: 'Ajustes manuais',
        uncategorized: 'Sem categoria',
        // Cabeçalho do grupo de compras feitas na própria competência da fatura. Os
        // demais grupos usam o nome do mês da compra.
        originCurrentMonth: 'Compras deste mês',
        manualAdjustedEmpty: 'O valor desta fatura foi ajustado manualmente. Ainda não há itens individuais vinculados.',
        emptyTitle: 'Sua fatura está vazia',
        emptySubtitle: 'Importe o PDF do banco e comece com tudo lançado e já categorizado.',
        importButton: 'Importar fatura do banco',
        limitLabel: 'Limite',
        limitUsedRow: 'Usado',
        limitUsedOf: '{{used}} de {{total}}',
        limitCardRow: 'Limite do cartão',
        limitPocketRow: 'Garantido por caixinha',
        limitPocketRowHint: 'a reserva soma ao limite disponível',
        limitPocketBoost: '+{{amount}}',
        paymentsPaidSummary: '{{amount}} pagos',
        paymentsPaidInFullSingle: 'Pagamento completo',
        paymentsPaidInFull: 'Pago integralmente',
        paymentsPaidSingleMeta: '{{amount}} · {{date}}',
        paymentsPaidMultiMeta_one: '{{amount}} · {{count}} pagamento',
        paymentsPaidMultiMeta_other: '{{amount}} · {{count}} pagamentos',
        paymentsCount_one: '{{count}} pagamento',
        paymentsCount_other: '{{count}} pagamentos',
        paymentsCountRemaining_one: '{{count}} pagamento · restam {{remaining}}',
        paymentsCountRemaining_other: '{{count}} pagamentos · restam {{remaining}}',
        noPaymentAccountTitle: 'Escolha a conta que paga esta fatura',
        noPaymentAccountBody: 'Sem ela, a fatura conta no saldo previsto, mas não aparece no previsto de nenhuma conta nem na lista de lançamentos.',
        payInvoiceButton: 'Pagar fatura',
        quickImport: 'Importar',
        quickAdjustTotal: 'Ajustar total',
        quickAnalysis: 'Análise',
        quickReport: 'Relatório',
        lastPayment: 'Último pagamento',
        undoLastPayment: 'Desfazer último pagamento',
        undoPaymentA11y: 'Desfazer pagamento de {{amount}} em {{date}}',
        cancel: 'Cancelar',
        selectedCount_one: '{{count}} selecionado',
        selectedCount_other: '{{count}} selecionados',
        selectAll: 'Tudo',
        itemsTitle: 'Itens da fatura',
        itemsInAccrual_one: '{{count}} item na competência',
        itemsInAccrual_other: '{{count}} itens na competência',
        searchPlaceholder: 'Buscar por nome ou valor...',
        searchMatches: '{{count}} de {{total}} na competência',
        searchEmptyTitle: 'Nada nesta fatura',
        searchEmptySubtitle: 'Nenhum item com esse nome ou valor. Troque o mês acima para buscar em outra fatura.',
        select: 'Selecionar',
        tapToSelect: 'Toque nos itens para selecionar',
        changeCategoryCount: 'Alterar categoria ({{n}})',
        removeAdjustment: 'Remover ajuste',
        confirmAdjustment: 'Confirmar ajuste',
        adjustSheetTitle: 'Ajustar valor da fatura',
        adjustAmountLabel: 'Valor total da fatura',
        analysisTitle: 'Análise da fatura',
        analysisByCategory: 'Categorias',
        analysisByTag: 'Tags',
        untagged: 'Sem tag',
        topComposition: 'Maior composição',
        noItems: 'Sem itens',
        notEnoughForAnalysis: 'Ainda não há itens suficientes para análise nesta fatura.',
        activeInstallmentPlans: 'Parcelamentos ativos',
        installmentMonthly: '{{amount}}/mês · {{paid}}/{{total}}',
        simulateInstallment: 'Simular parcelamento',
        committedNextMonths: 'Comprometido nos próximos meses',
        undoPaymentDialogTitle: 'Desfazer pagamento',
        undoPaymentDialogMessage: 'Remover o pagamento de {{amount}} em {{date}}{{account}}?',
        undoPaymentAccountSuffix: ' feito pela conta {{account}}',
        undoConfirm: 'Desfazer',
        deleteInstallmentDialogTitle: 'Excluir parcelamento',
        deleteInstallmentDialogMessage: 'Excluir "{{description}}" e todas as suas parcelas?',
        deleteSelected: 'Excluir selecionados',
        batchDeleteDialogTitle_one: 'Excluir {{count}} lançamento',
        batchDeleteDialogTitle_other: 'Excluir {{count}} lançamentos',
        batchDeleteDialogMessage_one: 'O lançamento sai da fatura e o total é recalculado. Pagamentos e ajustes da fatura não são afetados.',
        batchDeleteDialogMessage_other: 'Os lançamentos saem da fatura e o total é recalculado. Pagamentos e ajustes da fatura não são afetados.',
        batchDeleteInstallmentSeries_one: '{{count}} parcela pertence a uma compra parcelada — a compra inteira será excluída, incluindo as parcelas de outras faturas.',
        batchDeleteInstallmentSeries_other: '{{count}} parcelas pertencem a compras parceladas — as compras inteiras serão excluídas, incluindo as parcelas de outras faturas.',
        batchDeleteInstallmentHint_one: 'Há parcela de compra parcelada na seleção: excluir apaga a compra inteira, com todas as parcelas.',
        batchDeleteInstallmentHint_other: 'Há parcelas de compras parceladas na seleção: excluir apaga as compras inteiras, com todas as parcelas.',
    },
    report: {
        headerTitle: '{{name}} · {{period}}',
        totalFiltered: 'Total filtrado',
        itemsLabel: 'Itens',
        byTagTitle: 'Total por tag',
        untagged: 'Sem tag',
        tagItemCount_one: '{{count}} item',
        tagItemCount_other: '{{count}} itens',
        pdfColTag: 'Tag',
        // Rótulo de LINHA de filtro (FilterRow) — curto, pra sobrar largura ao valor.
        filterByCategory: 'Categorias',
        selectedCategoriesCount_one: '{{count}} selecionada',
        selectedCategoriesCount_other: '{{count}} selecionadas',
        allCategories: 'Todas as categorias',
        noCategoriesInInvoice: 'Sem categorias nesta fatura.',
        filterByTag: 'Tags',
        allTags: 'Todas as tags',
        emptyFilter: 'Nenhum lançamento com esse filtro.',
        uncategorized: 'Sem categoria',
        exportPdf: 'Exportar PDF',
        // Relatório aberto a quem não é Pro (26/09/2026): a tela real, valores borrados, o total à vista.
        locked: {
            caption: 'Seu relatório já está pronto',
            ctaTrial: 'Ver meu relatório · {{period}} grátis',
            ctaPlans: 'Ver meu relatório com o Pro',
            trialTerms: 'Depois, {{price}}/ano · cancele quando quiser',
            notNow: 'Agora não',
            unlocked: 'Pronto: seu relatório está liberado',
        },
        exportError: 'Erro ao exportar',
        filterCategorySingle: 'Categoria: {{name}}',
        filterCategoryMulti: '{{n}} categorias',
        filterTagSingle: 'Tag: {{name}}',
        filterTagMulti: '{{n}} tags',
        pdfTitle: 'Fatura {{name}}',
        pdfTotalLabel: 'Total',
        pdfSectionTitle: 'Lançamentos',
        pdfColData: 'Data',
        pdfColDescription: 'Descrição',
        pdfColCategory: 'Categoria',
        pdfColAmount: 'Valor',
    },
    selector: {
        title: 'Selecionar cartão',
        allCards: 'Todos os cartões',
        addCard: 'Adicionar cartão',
        limit: 'Limite: {{amount}}',
        emptyTitle: 'Nenhum cartão cadastrado',
        emptySubtitle: 'Adicione um cartão para vincular esta compra e continuar.',
    },
    simulator: {
        title: 'Simular parcelamento',
        descriptionLabel: 'Descrição',
        descriptionPlaceholder: 'Ex: Notebook, Celular...',
        totalLabel: 'Valor total',
        installmentCountLabel: 'Número de parcelas',
        perInstallmentLabel: 'Valor por parcela',
        perInstallmentValue: '{{installments}}x de {{amount}}',
        statementImpact: 'Impacto por fatura',
        moreMonths_one: '+{{count}} mês...',
        moreMonths_other: '+{{count}} meses...',
        confirm: 'Confirmar parcelamento',
    },
};
